import { useTableActionContext } from '@aibees/elephant/context';
import { Label, LabelType } from '@aibees/elephant/types/label';
import { uniqBy } from 'lodash-es';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  LabelManagementContextData as ContextData,
  ListManagementContextProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useLabelManagementContext = () => useContext(context);

export const LabelManagementProvider = ({
  children,
  onChangeLabels,
  type,
  overrideLabels,
}: ContextProps & { type?: LabelType }) => {
  const {
    labels: globalLabels,
    lists: globalLists,
    setLabels: setGlobalLabels,
    setLists: setGlobalLists,
  } = useTableActionContext();
  const labels = useMemo(
    () => (type === LabelType.LIST ? globalLists : globalLabels),
    [type, globalLists, globalLabels]
  );
  const setLabels = type === LabelType.LIST ? setGlobalLists : setGlobalLabels;

  const [justCreatedLabels, setJustCreatedLabels] = useState<Label[]>([]);

  const onClear = () => {
    setLabels([]);
  };

  const onSelect = (items?: Label[]) => {
    setLabels(uniqBy(items, 'id'));
  };

  const onRemove = (id: string) => {
    const draft = labels.filter((item) => item.id !== id);
    setLabels(draft);
  };

  useEffect(() => {
    onChangeLabels?.(labels);
  }, [onChangeLabels, labels]);

  return (
    <Provider
      value={{
        onSelect,
        labels,
        onRemove,
        onClear,
        justCreatedLabels,
        setJustCreatedLabels,
        overrideLabels,
      }}
    >
      {children}
    </Provider>
  );
};
